/* eslint-disable */
const MESSANGER = {
  MESSAGING_REPORT_COMPANY_SENT: 'messaging/report/company/sent',
  MESSAGING_REPORT_COMPANY_RECEIVED: 'messaging/report/company/received',
  MESSAGING_TYPE_REPORT_TEMPLATE: 'messaging/type/report/template',
  MESSAGING_TYPE_DISABLE_TEMPLATE: 'messaging/type/disable/template',
  MESSAGING_TYPE_ENABLE_TEMPLATE: 'messaging/type/enable/template',
  MESSAGING_TYPE_EDIT_TEMPLATE: 'messaging/type/edit/template',
  MESSAGING_TYPE_DELETE_TEMPLATE: 'messaging/type/delete/template',
  MESSAGING_TYPE_ADD_TEMPLATE: 'messaging/type/add/template',
  MESSAGING_TYPE_LIST_TEMPLATE: 'messaging/type/list/template',
  MESSAGING_OPERATION_COMPANY_SEND: 'messaging/operation/company/send',
  MESSAGING_OPERATION_COMPANY_GET: 'messaging/operation/company/get',
  MESSAGING_OPERATION_COMPANY_EDIT_DETAIL: 'messaging/operation/company/edit/detail',
  MESSAGING_OPERATION_COMPANY_EDIT_STATUS: 'messaging/operation/company/edit/status'
}
export default MESSANGER
